import { countriesActions } from "../../actionTypes";

const initialState = {
	timezones: {},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) => {
	switch (action.type) {
		case countriesActions.FETCH_TIMEZONES: {
			return { ...state, fetching: true };
		}

		case countriesActions.FETCH_TIMEZONES_FULFILLED: {
			return {
				...state,
				fetching: false,
				fetched: true,
				cities: action.payload,
			};
		}

		case countriesActions.FETCH_TIMEZONES_REJECTED: {
			return { ...state, fetching: false, error: action.payload };
		}

		default:
			return state;
	}
};
export default Reducer;
